module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/direccion/direccion.component.css
// module id = ./src/app/components/direccion/direccion.component.css
// module chunks = main